<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="initDeviceId">
          <el-input
            v-model="queryForm.initDeviceId"
            @keyup.enter.native="query"
            placeholder="初始设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="oldDeviceId">
          <el-input
            v-model="queryForm.oldDeviceId"
            @keyup.enter.native="query"
            placeholder="原设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="newDeviceId">
          <el-input
            v-model="queryForm.newDeviceId"
            @keyup.enter.native="query"
            placeholder="新设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="operationAccount">
          <el-input
            v-model="queryForm.operationAccount"
            @keyup.enter.native="query"
            placeholder="创建人员"
          ></el-input>
        </el-form-item>
        <el-button
          v-if="hasPerm('device:replace:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('device:replace:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          size="medium"
          v-if="hasPerm('device:replace:add')"
          type="primary"
          @click="addDeviceReplace"
          >新增</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('device:replace:modify')"
          type="primary"
          @click="editDeviceReplace"
          >修改</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('device:replace:delete')"
          type="danger"
          @click="delREeplaceRecord"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
      >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="vin"
        label="车架号"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="initDeviceId"
        label="初始设备编号"
      ></el-table-column>
      <el-table-column prop="oldDeviceId" label="原设备编号"></el-table-column>
      <el-table-column prop="newDeviceId" label="新设备编号"></el-table-column>
      <el-table-column
        prop="oldEcuSerialNum"
        label="原电控单元序列号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="newEcuSerialNum"
        label="新电控单元序列号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="replaceTime"
        label="更换时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operationAccount"
        label="创建人员"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="addTime"
        label="创建时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('device:replace:details')"
              @click.stop="clickDeviceInfo(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--新增弹窗-->
    <el-dialog
      :title="deviceReplaceTitle"
      :visible.sync="addDeviceReplaceVisible"
      class="vehicle-dialog"
      >
      <el-form
        :rules="deviceReplaceRules"
        ref="deviceReplaceForm"
        :model="deviceReplaceForm"
        size="mini"
        :inline="true"
      >
        <el-form-item label="创建人员">
          <el-row>{{operationAccount}}</el-row>
        </el-form-item>
        <el-form-item prop="replaceTime" label="更换时间">
          <el-date-picker
            :disabled="disabledId"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="deviceReplaceForm.replaceTime"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="oldEcuSerialNum" label="原电控单元序列号">
          <el-input
            :disabled="disabledId"
            v-model="deviceReplaceForm.oldEcuSerialNum"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="newEcuSerialNum" label="新电控单元序列号">
          <el-input
            :disabled="disabledId"
            v-model="deviceReplaceForm.newEcuSerialNum"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            resize="none"
            style="font-size:14px"
            v-model="deviceReplaceForm.remark"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
        <el-button @click="addDeviceReplaceVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      title="查看设备更换记录"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
      >
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">创建人员</el-col>
        <el-col :span="17">{{
          $judgeEmpty(deviceReplaceInfo.operationAccount)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">更换时间</el-col>
        <el-col :span="17">{{
          $judgeEmpty(deviceReplaceInfo.replaceTime)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">原电控单元序列号</el-col>
        <el-col :span="17">{{ $judgeEmpty(deviceReplaceInfo.oldEcuSerialNum) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">新电控单元序列号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(deviceReplaceInfo.newEcuSerialNum)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">初始设备编号</el-col>
        <el-col :span="17">{{ $judgeEmpty(deviceReplaceInfo.initDeviceId) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">原设备编号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(deviceReplaceInfo.oldDeviceId)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">新设备编号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(deviceReplaceInfo.newDeviceId)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">备注</el-col>
        <el-col :span="17">{{
          $judgeEmpty(deviceReplaceInfo.remark)
        }}</el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        initDeviceId: "",
        oldDeviceId: "",
        newDeviceId: "",
        operationAccount:''
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      infoVisible:false,
      deviceReplaceInfo: {},
      operationAccount:"",
      deviceReplaceTitle:'新增设备更换记录',
      addDeviceReplaceVisible:false,
      deviceReplaceForm:{},
      disabledId:false,
      deviceReplaceRules: {
        replaceTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择更换时间",
          },
        ],
        oldEcuSerialNum: [
          {
            required: true,
            trigger: "change",
            message: "请输入原电控单元序列号",
          },
        ],
        newEcuSerialNum: [
          {
            required: true,
            trigger: "change",
            message: "请输入新电控单元序列号",
          },
        ],
        remark: [
          {
            required: true,
            trigger: "change",
            message: "请输入更换备注",
          },
        ],
      },
    }
  },
  created() {
    this.getRecordList()
  },
  methods: {
    async getRecordList() {
      let _this = this
      let obj = {}
      obj.initDeviceId = _this.queryForm.initDeviceId
      obj.oldDeviceId = _this.queryForm.oldDeviceId
      obj.newDeviceId = _this.queryForm.newDeviceId
      obj.operationAccount = _this.queryForm.operationAccount
      obj.limit = _this.limit
      obj.page = _this.currentPage
      let { data: res } = await _this.$axios.get("/api/device/replace/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getRecordList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getRecordList()
    },
    addDeviceReplace() {
      this.$resetForm(this, "deviceReplaceForm")
      this.operationAccount = sessionStorage.getItem("user")
      this.deviceReplaceTitle="新增设备更换记录"
      this.deviceReplaceForm={}
      this.disabledId=false
      this.addDeviceReplaceVisible = true
    },
    saveOrUpdate() {
      let _this = this
      _this.$refs.deviceReplaceForm.validate(async (valid) => {
        if (valid) {
          if (_this.deviceReplaceTitle == "新增设备更换记录") {
            let { data: res } = await _this.$axios.post(
              "/api/device/replace",
              _this.deviceReplaceForm
            )
            if (res.code == 1) {
              _this.addDeviceReplaceVisible = false
              _this.$resetForm(_this, "deviceReplaceForm")
              _this.getRecordList()
              _this.$message.success("操作成功")
            } else {
              _this.$message.warning(res.msg)
            }
          } else {
            let { data: res } = await _this.$axios.patch(
              "/api/device/replace?id="+_this.deviceReplaceForm.id+'&remark='+_this.deviceReplaceForm.remark
            )
            if (res.code == 1) {
              _this.addDeviceReplaceVisible = false
              _this.$resetForm(_this, "deviceReplaceForm")
              _this.getRecordList()
              _this.$message.success("操作成功")
            } else {
              _this.$message.warning(res.msg)
            }
          }
        }
      })
    },
    // 修改
    async editDeviceReplace(){
      let _this = this
      let id = _this.$getIds(_this.tableVal)
      if (!id) {
        return
      }else if(id.length>1){
        _this.$message.warning('只能选择一条数据')
        return
      }
      let { data: res } = await _this.$axios.get(
        "/api/device/replace/details/" + id
      )
      if (res.code == 1) {
        _this.deviceReplaceForm = res.data
        _this.operationAccount=_this.deviceReplaceForm.operationAccount
        _this.deviceReplaceTitle="修改设备更换记录"
        _this.deviceReplaceForm.id=id[0]
        _this.disabledId=true
        _this.addDeviceReplaceVisible = true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    // 查看详情
    async clickDeviceInfo(rowData){
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/device/replace/details/" + rowData.id
      )
      if (res.code == 1) {
        _this.deviceReplaceInfo = res.data
        _this.infoVisible = true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    // 删除
    delREeplaceRecord() {
      let _this = this
      //多选删除
      let ids = _this.$getIds(_this.tableVal)
      if (!ids) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/device/replace", {
            data: JSON.stringify(ids),
          })
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getRecordList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getRecordList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
//新增弹窗
.vehicle-dialog /deep/ .el-dialog {
  width: 600px;
}
.vehicle-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
}
.vehicle-dialog /deep/ .el-date-editor.el-input {
  width: 360px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 260px;
}
// 详情弹窗
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.info-box /deep/ .el-dialog__body {
  padding-left: 40px;
}
.info-box /deep/ .el-dialog__footer {
  padding-top: 10px;
}
.dialog-label {
  padding-left: 20px;
  font-weight: bold;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
</style>
